import { CSSProperties } from 'react';

export default function Email({ s }: { s?: CSSProperties }) {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...s, verticalAlign: 'middle' }}
    >
      <path
        d="M21.6878 17.2752H19.7057C18.935 17.2752 18.3103 16.6504 18.3103 15.8797V15.2931C18.3103 14.5224 18.935 13.8977 19.7057 13.8977H20.2923C21.063 13.8977 21.6878 14.5224 21.6878 15.2931V17.2752Z"
        stroke="#1399D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6878 17.272C23.9581 17.2352 23.8941 15.4522 23.8941 15.4522C23.8941 13.243 22.2082 11.587 19.999 11.587C17.7899 11.587 15.999 13.3779 15.999 15.5871C15.999 17.7962 17.7899 19.587 19.999 19.587C20.9476 19.587 21.819 19.2569 22.5046 18.7052"
        stroke="#1399D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_1267_18636)">
        <mask
          id="mask0_1267_18636"
          maskUnits="userSpaceOnUse"
          x="4"
          y="4"
          width="32"
          height="32"
        >
          <path d="M4 4H36V36H4V4Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1267_18636)">
          <mask id="path-4-inside-1_1267_18636" fill="white">
            <path d="M14.6588 19.1421C14.2105 18.8247 13.7901 18.4697 13.4022 18.0808L5.12524 9.78796M35.2299 9.7894L26.9524 18.0813C26.6951 18.3393 26.4233 18.5825 26.1385 18.8097" />
          </mask>
          <path
            d="M13.4022 18.0808L14.1101 17.3745L14.11 17.3744L13.4022 18.0808ZM26.9524 18.0813L26.2447 17.3748L26.2444 17.3751L26.9524 18.0813ZM15.2367 18.326C14.8348 18.0414 14.4579 17.7231 14.1101 17.3745L12.6943 18.7871C13.1224 19.2162 13.5863 19.608 14.081 19.9583L15.2367 18.326ZM14.11 17.3744L5.83303 9.08154L4.41746 10.4944L12.6944 18.7873L14.11 17.3744ZM34.5222 9.08291L26.2447 17.3748L27.6601 18.7878L35.9376 10.4959L34.5222 9.08291ZM26.2444 17.3751C26.0138 17.6063 25.7702 17.8243 25.5149 18.0279L26.762 19.5914C27.0765 19.3407 27.3764 19.0722 27.6604 18.7875L26.2444 17.3751Z"
            fill="#250058"
            mask="url(#path-4-inside-1_1267_18636)"
          />
          <path
            d="M5.12378 9.78796L17.6676 22.356C19.0524 23.7436 21.3013 23.7437 22.6863 22.3563L35.2284 9.79219"
            stroke="#250058"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.909 9.52732V29.768H35.47V9.5301L4.909 9.52722V9.52732Z"
            stroke="#250058"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1267_18636">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
